import { Link } from "react-router-dom";
import { useSettings, useTexts } from "../lib/settings";
import { Words } from "../components/Reveal";
import { COPY } from "../content/copy";
import { CookieSettingsButton } from "../components/consent/ConsentProvider";

export default function Footer() {
    const f = COPY.footer;
    const extra = useSettings().links || [];
    const t = useTexts();
    return (
        <footer className="footer" data-testid="footer">
            <div className="container">
                <p className="display footer-line" data-testid="footer-headline">
                    <Words text={t.headline_a} /> <Words text={t.headline_b} italic />
                </p>
            </div>
            <div
                className="footer-mark"
                aria-hidden="true"
                data-testid="footer-mark"
                onPointerMove={(e) => {
                    const r = e.currentTarget.getBoundingClientRect();
                    e.currentTarget.style.setProperty("--mx", `${((e.clientX - r.left) / r.width) * 100}%`);
                }}
                onPointerLeave={(e) => e.currentTarget.style.removeProperty("--mx")}
            >
                <span className="footer-mark-text">APF Partners</span>
            </div>
            <div className="footer-bar">
                <div className="container footer-row">
                    <span className="footer-brand">{COPY.brand}</span>
                    <span className="caption">{f.vat}</span>
                    <nav className="footer-links" aria-label="Footer">
                        <Link className="tlink" to="/cookie" data-testid="footer-cookie-policy">Cookie</Link>
                        <CookieSettingsButton testId="footer-cookie-settings" />
                        {[...f.links, ...extra].map((l) =>
                            l.href.startsWith("/") ? (
                                <Link
                                    key={l.label}
                                    className="tlink"
                                    to={l.href}
                                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                                >
                                    {l.label}
                                </Link>
                            ) : (
                                <a
                                    key={l.label}
                                    className="tlink"
                                    href={l.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                                >
                                    {l.label}
                                </a>
                            )
                        )}
                    </nav>
                </div>
            </div>
        </footer>
    );
}
